import styled from "styled-components";

const VersionText = styled.span`
  font-size: var(--font-size-xs, 0.75rem);
  color: var(--text-muted, #999);
  opacity: 0.6;
  padding: 8px 0;
  user-select: none;
`;

const AppVersion = () => {
  return <VersionText>v{__APP_VERSION__}</VersionText>;
};

export default AppVersion;